export class Constants {

  static readonly errorCodeTicketNotFound: string = 'ticket_not_found';
  static readonly errorCodeTicketAlreadyUsed: string = 'ticket_already_used';
}
